import React from 'react';
import { Section } from './Section';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function WhatYouGetSection() {
  const deliverables = [{
    title: 'The 168-Hour Transformation Map',
    desc: 'A day-by-day guide to flushing and sculpting.'
  }, {
    title: "The Internal 'De-Bloat' Stack",
    desc: 'The 4 specific micronutrients that act as natural fluid movers.'
  }, {
    title: 'The 5-Minute Manual Sculpt',
    desc: "Three professional-grade movements to 'pop' your jawline and cheekbones."
  }, {
    title: 'The De-Inflammatory Grocery List',
    desc: 'Exactly what to eat for 7 days to stay sharp and defined.'
  }, {
    title: "BONUS: The 'Morning Mirror' Checklist",
    desc: 'A 2-minute ritual to ensure you never leave the house puffy again.',
    isBonus: true
  }];
  return <Section bg="white" data-id="element-170">
      <div className="text-center mb-16" data-id="element-171">
        <h2 className="text-4xl md:text-5xl font-serif mb-4" data-id="element-172">What You Get</h2>
        <p className="text-lg text-charcoal/60" data-id="element-173">
          Everything you need to reveal your true bone structure.
        </p>
      </div>

      <div className="max-w-3xl mx-auto space-y-4" data-id="element-174">
        {deliverables.map((item, index) => <motion.div key={index} initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className={`p-6 rounded-2xl flex items-start ${item.isBonus ? 'bg-gold/10 border border-gold/30' : 'bg-cream border border-sage/10'}`} data-id="element-175">
            <CheckCircle2 className={`w-6 h-6 shrink-0 mr-4 mt-1 ${item.isBonus ? 'text-gold' : 'text-sage'}`} data-id="element-176" />
            <div data-id="element-177">
              <h4 className="font-semibold text-lg mb-1" data-id="element-178">
                {item.isBonus && <span className="text-gold uppercase text-sm tracking-wider mr-2 font-bold" data-id="element-179">
                    Bonus:
                  </span>}
                {item.title}
              </h4>
              <p className="text-charcoal/70" data-id="element-180">{item.desc}</p>
            </div>
          </motion.div>)}
      </div>
    </Section>;
}